module.exports = __webpack_public_path__ + "static/img/client_new_en1.10589695.png";